import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import './CustomToast.css';

interface CustomToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  duration?: number;
}

const CustomToast: React.FC<CustomToastProps> = ({ message, type = 'success' }) => {
  return (
    <div className={`custom-toast custom-toast--${type}`}>
      <div className="custom-toast__icon">
        {type === 'success' && '✓'}
        {type === 'error' && '✕'}
        {type === 'info' && 'ℹ'}
      </div>
      <div className="custom-toast__content">
        <div className="custom-toast__message">{message}</div>
      </div>
    </div>
  );
};

// Store the current toast ID to update existing toasts
let currentToastId: any = null;

export const showCustomToast = (message: string, type: 'success' | 'error' | 'info' = 'success', duration: number = 1500) => {
  const toastOptions: ToastOptions = {
    position: 'top-center',
    autoClose: duration,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    closeButton: false,
    className: 'custom-toast-container',
  };

  // If there's already a toast showing, update it instead of creating a new one
  if (currentToastId) {
    toast.update(currentToastId, {
      render: <CustomToast message={message} type={type} />,
      ...toastOptions
    });
  } else {
    currentToastId = toast(<CustomToast message={message} type={type} />, {
      ...toastOptions,
      onClose: () => {
        currentToastId = null;
      }
    });
  }

  return currentToastId;
};

export default CustomToast;
